export enum EditEventOption {
  EditSingleOnlyEvent = 'SINGLE',
  EditSingleEvent = 'THIS_EVENT',
  EditFutureEvent = 'THIS_AND_FUTURE',
  EditWholeSeries = 'ALL',
}